<template>
	<div class="display-flex">
		<h3 v-if="allowDismiss" @click="$emit('dismiss')" class="reg dismiss">Dismiss</h3>
		<div class="ml-6">
			<AppLoader v-if="isLoading" />
			<h3 @click="$emit('save')" class="reg save" v-else>Save</h3>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DismissSaveButtons',
	props: { isLoading: { type: Boolean }, allowDismiss: { type: Boolean, default: true } },
};
</script>

<style lang="scss" scoped>
.footer-button {
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}
}
.dismiss {
	@extend .footer-button;
	color: #949394;
}
.save {
	@extend .footer-button;
	color: #6964eb;
}
</style>
